<template>
  <div id="app" :class="{'app-ios':'ios'==os, 'app-andr':'ios'!=os}">
    <dm-header
      :title="title"
      :showRightBtn="showRightBtn"
      rightBtnType="text"
      :rightText="rightText"
      :hasLeftCallbackFunc ="hasHeadLCallbackFunc"
      @click-left-btn="clickHeadLBtn"
      @click-left-btn-back="clickHeadLBtnBack"
      @click-right-btn="clickHeadRBtn">
    </dm-header>
    <!-- <transition :name="transationName"> -->
      <router-view></router-view>
    <!-- </transition> -->
    <div v-show="dataDarkMask" class="d-dark-mask" :class="{'d-dark-mask-ios': os == 'ios'}"></div>
    <div v-show="dataTransMask" class="d-trans-mask" :class="{'d-trans-mask-ios': os == 'ios'}"></div>
    <div v-show="clickDarkMask" class="d-click-dark-mask" :class="{'d-dark-mask-ios': os == 'ios'}"
      @click="clickDarkMaskFunc"></div>
    <div v-show="clickTransMask" class="d-click-trans-mask" :class="{'d-trans-mask-ios': os == 'ios'}"
      @click="clickTransMaskFunc"></div>
    <div  v-show="dataMsgBox" class="msg-box">
      <p>{{msgBoxContent}}</p>
    </div>
    <div  v-show="dataWhiteMsgBox" class="msg-box msg-box-white">
      <p>{{msgBoxContent}}</p>
    </div>
    <div v-show="dataLoading" class="d-loading-box">
      <div class="sprite sprite-load d-loading"></div>
      <p v-show="dataLoading&&!openGLoading">{{this.$t('commonLoading')}}</p>
      <p v-show="dataLoading&&openGLoading">{{this.$t('openGLoading')}}</p>
    </div>
  </div>
</template>

<script>
  import util from './global/util.js';
  export default {
    name: 'App',
    created() {
      let queryObj={};
      let arrTemp = [];
      window.location.search.substr(1).split('&').map((item)=> {
        arrTemp = item.split('=');
        queryObj[arrTemp[0]] = arrTemp[1];
      });
      let clientId = decodeURIComponent(queryObj.client_id);
      let apiAddr = decodeURIComponent(queryObj.api_address);
      let blobApiAddr = decodeURIComponent(queryObj.blob_api_address);
      this.$store.state.lan?(this.$i18n.locale = this.$store.state.lan):null;
      this.$forceUpdate();
    },
    watch: {
      $route(to, from) {
        let toPage = to.path.substr(1);
        let fromPage = to.query.from;
        let timeoutMs = 250;
        this.$store.commit('showTransMask');
        if('wire'==toPage&&'location'==fromPage&&'ios'==this.$store.getters.getOs) {
          timeoutMs = 380;
        }
        this.$store.commit('showTransMask');
        setTimeout(()=>{
          this.$store.commit('hideTransMask');
        }, timeoutMs);
        this.$store.commit('hideDarkMask');
        this.$store.commit('hideClickDarkMask');
        this.$store.commit('hideLoading');
        this.$store.commit('hideMsg');
        if('test'==toPage||'result'==toPage) {
          document.title = 'garage door guide';
        } else {
          document.title = 'garage door guide';
        }
      }
    },
    data() {
      return {
        transationName: '',
      };
    },
    computed: {
      title() {
        return this.$store.state.titleObj.currentTitle;
      },
      showRightBtn() {
        return this.$store.state.titleObj.showRightBtn;
      },
      rightText() {
        return this.$store.state.titleObj.rightText;
      },
      hasHeadLCallbackFunc() {
        return this.$store.state.titleObj.hasLCallbackFunc;
      },
      os() {
        return this.$store.state.os;
      },
      // showMask() {
      //   return this.$store.state.showMask;
      // },
      dataDarkMask() {
        return this.$store.state.dataDarkMask;
      },
      dataTransMask() {
        return this.$store.state.dataTransMask;
      },
      clickDarkMask() {
        return this.$store.state.clickDarkMask;
      },
      clickTransMask() {
        return this.$store.state.clickTransMask;
      },
      dataLoading() {
        return this.$store.state.dataLoading;
      },
      openGLoading() {
        return this.$store.state.openGLoading;
      },
      dataMsgBox() {
        return this.$store.state.dataMsgBox;
      },
      dataWhiteMsgBox() {
        return this.$store.state.dataWhiteMsgBox;
      },
      msgBoxContent() {
        return this.$store.state.msgBoxContent;
      }
    },
    methods: {
      clickHeadRBtn() {
        this.$store.state.titleObj.rightFun?this.$store.state.titleObj.rightFun():null;
      },
      clickHeadLBtn() {
        // console.log('clickHeadLBtn');
        // console.log(this.$store.state.titleObj);
        this.$store.state.titleObj.leftFun?this.$store.state.titleObj.leftFun():null;
      },
      clickHeadLBtnBack() {
      },
      clickDarkMaskFunc() {
        this.$store.state.clickDarkMaskCallbackFunc?this.$store.state.clickDarkMaskCallbackFunc():this.$store.commit('hideClickDarkMask');
      },
      clickTransMaskFunc() {
        // console.log('click click click');
        this.$store.state.clickTransMaskCallbackFunc?this.$store.state.clickTransMaskCallbackFunc():this.$store.commit('hideClickDarkMask');
      },
    }
  };
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  /*display: flex;
  flex-direction: column;*/
}

.slide-right-ios-leave-active,
.slide-left-ios-leave-active,
.slide-right-android-leave-active,
.slide-left-android-leave-active {
  /*will-change: transform;*/
  transition: transform 200ms ease;
  /*position: absolute;*/
}
.slide-right-ios-enter-active,
.slide-left-ios-enter-active,
.slide-right-android-enter-active,
.slide-left-android-enter-active {
  transition: transform 200ms ease;
  position: absolute;
}
.slide-right-ios-leave-active,
.slide-left-ios-leave-active,
.slide-right-ios-enter-active,
.slide-left-ios-enter-active {
  top: 45px;
}
.slide-right-android-leave-active,
.slide-left-android-leave-active,
.slide-right-android-enter-active,
.slide-left-android-enter-active {
  top: 49px;
}
.slide-right-ios-enter,
.slide-right-android-enter {
  /*opacity: 0;*/
  transform: translateX(-100%);
}
.slide-right-ios-leave-active,
.slide-right-android-leave-active {
  /*opacity: 0;*/
  transform: translateX(100%);
}
.slide-left-ios-enter,
.slide-left-android-enter {
  /*opacity: 0;*/
  transform: translateX(100%);
}
.slide-left-ios-leave-active,
.slide-left-android-leave-active {
  /*opacity: 0;*/
  transform: translateX(-100%);
}
  .msg-box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(34, 34, 34, .7);
    min-width: 50%;
    min-height: 20px;
    padding: 10px 6px;
    font-size: 14px;
    line-height: 20px;
    white-space: normal;
    word-break: break-word;
    border-radius: 6px;
    z-index: 90000;
  }
  .msg-box-white {
    box-sizing: border-box;
    width: 80%;
    max-width: 600px;
    background-color: #fff;
    padding: 20px;
    border-radius: 15px;
  }
  .msg-box p {
    color: #fff;
    font-size: 14px;
    line-height:20px;
    text-align: center;
  }
  .msg-box-white p {
    color: #777;
  }
  .d-dark-mask {
    position: fixed;
    top:48px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 70000;
    background-color: rgba(0, 0, 0, .5);
  }
  .d-dark-mask-ios {
    top: 44px;
  }
  .d-trans-mask {
    position: fixed;
    top:48px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 70000;
    background-color: rgba(255, 255, 255, 0);
  }
  .d-trans-mask-ios {
    top: 44px;
  }
  .d-loading-box {
    position: fixed;
    bottom: 50%;
    left: 0;
    right:0;
    z-index: 70000;
  }
  .d-loading {
    width: 20px;
    height: 20px;
    position: relative;
    left: 50%;
    animation:loadKF 1s linear infinite;
  }
  .d-loading-box p {
    position: relative;
    margin-top: 15px;
    left: 10px;
    font-size: 14px;
    line-height: 14px;
    color: #fff;
    text-align: center;
  }
  @keyframes loadKF {
    from {
      transform: rotate(0deg);
    } to {
      transform: rotate(360deg);
    }
  }
  .d-click-dark-mask {
    position: fixed;
    top:48px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    background-color: rgba(0, 0, 0, .5);
  }
  .d-click-trans-mask {
    position: fixed;
    top:48px;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, 0);
  }
  .app-ios {
    padding-top:44px;
  }
  .app-andr {
    padding-top: 48px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue